import { Paginated } from "../../../../../store/api/upsellApi";
import Box from "@mui/material/Box";
import { Button, FormLabel, MenuItem, Select } from "@mui/material";
import React from "react";
import { usePagination } from "./usePagination";

export function Pagination({
  paginationResponse,
  page,
  setPage,
  perPage,
  setPerPage,
}: ReturnType<typeof usePagination> & {
  paginationResponse: Paginated<unknown> | undefined;
}) {
  return (
    <Box sx={{ p: 4, width: "100%", display: "flex", justifyContent: "space-between" }}>
      {paginationResponse ? (
        <Box sx={{ display: "flex", gap: 1, alignItems: "baseline" }}>
          <Button disabled={!paginationResponse.links.prev} onClick={() => setPage((p) => p - 1)}>
            Previous
          </Button>
          {paginationResponse.meta.links.slice(1, paginationResponse.meta.links.length - 1).map((link) => (
            <Button
              onClick={() => {
                const page = Number.parseInt(link.label, 10);
                if (Number.isFinite(page)) {
                  setPage(page);
                }
              }}
              size={"small"}
              sx={{
                width: "2em",
                height: "2em",
                borderRadius: "50%",
                background: link.active ? "primary" : "default",
                minWidth: "1em",
              }}
              variant={link.active ? "contained" : "outlined"}
            >
              {link.label}
            </Button>
          ))}
          <Button disabled={!paginationResponse.links.next} onClick={() => setPage((p) => p + 1)}>
            Next
          </Button>
        </Box>
      ) : null}
      <Box>
        <FormLabel sx={{ mr: 1 }}>Per page</FormLabel>
        <Select
          defaultValue={10}
          label={"Per page"}
          onChange={({ target: { value } }) => {
            return setPerPage(typeof value === "string" ? Number.parseInt(value, 10) : value);
          }}
        >
          {[10, 25, 50, 100, 1000].map((v) => (
            <MenuItem value={v}>{v}</MenuItem>
          ))}
        </Select>
      </Box>
    </Box>
  );
}
